import { Logger } from '@suntex.core/logging';

import { IconKey, icons } from '../assets';

const TARGET_WIDTH = 128;

const logger = Logger.for(() => ImageIcon);

export class ImageIcon extends createjs.Container {
  constructor(slug: IconKey) {
    super();
    const imgElement = new Image();
    imgElement.onload = () => {
      const bitmap = new createjs.Bitmap(imgElement);
      const { width, height } = imgElement;
      const scale = TARGET_WIDTH / Math.max(width, height);
      bitmap.setTransform(-TARGET_WIDTH / 2, -TARGET_WIDTH / 2, scale, scale);
      this.addChild(bitmap);
    };

    if (icons[slug]) {
      imgElement.src = icons[slug];
    } else {
      logger.error(`No icon found for '${slug}'`, { slug });
    }
  }
}
